const homeUrl = '/';
const learnUrl = `/learn`;
const learningRewardsUrl = '/learning-rewards';
const bytesUrl = '/bytes';

// Rails
const aboutUrl = `/about`;
const careersUrl = `/careers`;

// Footer - Support Column

const DefaultSupportRoutes = {
  consumerUrl: 'https://www.coinbase.com',
  helpCenterUrl: `https://help.coinbase.com`,
  statusUrl: `https://status.coinbase.com`,
  contactUsUrl: `/contact-us/`,
  createAccountUrl: `/coinbase/getting-started/getting-started-with-coinbase/create-a-coinbase-account/`,
  idVerificationUrl: `/coinbase/managing-my-account#identity-verification/`,
  accountInformationUrl: `/coinbase/managing-my-account/`,
  paymentMethodsUrl: `/coinbase/getting-started#add-a-payment-method/`,
  accountAccessUrl: `/coinbase/managing-my-account/`,
  supportedCountriesUrl: `/places/`,
  supportedCryptoUrl: `/supported-crypto.html`
};
const GermanRoutes = {
  idVerificationUrl: `https://help.coinbase.com/de/coinbase/managing-my-account/verify-my-identity/id-verification-for-german-customers`,
  contactUsUrl: `https://help.coinbase.com/de/contact-us`,
  supportedCryptoUrl: 'https://help.coinbase.com/en/supported-crypto.html'
};

// External
const statusUrl = `https://status.coinbase.com`;
const blogUrl = 'https://www.coinbase.com/blog';
const securityUrl = 'https://www.coinbase.com/security';
const xUrl = `https://x.com/coinbase`;
const xUkUrl = 'https://x.com/coinbaseuk';
const facebookUrl = `https://www.facebook.com/Coinbase`;

// Products
const commerceUrl = 'https://www.coinbase.com/commerce';
const primeUrl = '/prime';
const listingsUrl = 'https://www.coinbase.com/listings';
const walletUrl = 'https://wallet.coinbase.com';
const cardUrl = '/card';
const derivativesUrl = '/derivatives';
const taxesUrl = `/learn/crypto-basics/understanding-crypto-taxes`;
const investorsUrl = `https://investor.coinbase.com/`;
const exchangeUrl = '/exchange';
const internationalExchangeUrl = '/international-exchange';
const verifiedPoolsUrl = '/verified-pools';
const instoStakingUrl = '/staking';

// Developers or Cloud
const devPlatformUrl = 'https://www.coinbase.com/developer-platform';
const stakingUrl = 'https://www.coinbase.com/developer-platform/products/staking';
const onrampUrl = 'https://www.coinbase.com/developer-platform/products/onramp';
const embWalletsUrl = 'https://www.coinbase.com/developer-platform/products/wallets';
const exchangeApiUrl = 'https://www.coinbase.com/developer-platform/products/exchange-api';
const baseNodeUrl = 'https://www.coinbase.com/developer-platform/products/base-node';
const baseURL = 'https://base.org';
const coinbaseAppUrl = 'https://docs.cdp.coinbase.com/coinbase-app/docs/welcome';
const walletlinkUrl = 'https://docs.cloud.coinbase.com/wallet-sdk/docs/welcome';
const primeApiUrl = 'https://docs.cloud.coinbase.com/prime/docs';
const onchainKitUrl = 'https://onchainkit.xyz/';

// Footer
const vendors = '/vendors/vendors-at-coinbase';
const explore = '/explore';
const cryptoBasics = '/learn/crypto-basics';
const tipsAndTutorials = '/learn/tips-and-tutorials';
const cryptoGlossary = '/learn/crypto-glossary';
const marketUpdates = '/learn/market-updates';
const whatIsBlockchain = '/learn/crypto-basics/what-is-a-blockchain';
const whatIsBitcoin = '/learn/crypto-basics/what-is-bitcoin';
const whatIsCrypto = '/learn/crypto-basics/what-is-cryptocurrency';
const howToSetUpACryptoWallet = '/learn/tips-and-tutorials/how-to-set-up-a-crypto-wallet';
const howToSendCrypto = '/learn/tips-and-tutorials/how-to-send-crypto';
const pressUrl = `/press`;
const legalHomepageUrl = `/legal`;
const legalGermanyHomepageUrl = `/legal/germany`;
const legalAgreementUrl = `/legal/user_agreement`;
const cookiePolicyUrl = `/legal/cookie`;
const digitalAssetDisclosuresUrl = `/legal/digital-asset-disclosures`;
const modernSlaveryStatementUrl = `https://assets.ctfassets.net/o10es7wu5gm1/4QPckXz5ru71e8MZqdB891/3efb0396b75c8e0f0280abd697c3b90c/CBPL_-_Modern_Slavery_Statement_2020_2021_2022_2023.pdf`;
const impressumUrl = `/impressum`;
const affiliatesUrl = `/affiliates`;
const coinbaseOneUrl = `/one`;
export { DefaultSupportRoutes, GermanRoutes, aboutUrl, affiliatesUrl, baseNodeUrl, baseURL, blogUrl, bytesUrl, cardUrl, careersUrl, coinbaseAppUrl, coinbaseOneUrl, commerceUrl, cookiePolicyUrl, cryptoBasics, cryptoGlossary, derivativesUrl, devPlatformUrl, digitalAssetDisclosuresUrl, embWalletsUrl, exchangeApiUrl, exchangeUrl, explore, facebookUrl, homeUrl, howToSendCrypto, howToSetUpACryptoWallet, impressumUrl, instoStakingUrl, internationalExchangeUrl, investorsUrl, learnUrl, learningRewardsUrl, legalAgreementUrl, legalGermanyHomepageUrl, legalHomepageUrl, listingsUrl, marketUpdates, modernSlaveryStatementUrl, onchainKitUrl, onrampUrl, pressUrl, primeApiUrl, primeUrl, securityUrl, stakingUrl, statusUrl, taxesUrl, tipsAndTutorials, vendors, verifiedPoolsUrl, walletUrl, walletlinkUrl, whatIsBitcoin, whatIsBlockchain, whatIsCrypto, xUkUrl, xUrl };
//# sourceMappingURL=links.js.map
